document.addEventListener("DOMContentLoaded", () => {

  /* =========================================================
     WUBLUE STICKY CART
  ========================================================= */

  const sticky = document.getElementById("wbStickyCart");
  const stickyBtn = document.getElementById("wbStickyAddToCart");
  const buyBtn = document.getElementById("wbStickyBuyNow");

  if (!sticky || !stickyBtn) {
    console.warn("Wublue Sticky Cart: Elements not found.");
    return;
  }


  /* =========================================================
     FIND THE REAL SHOPIFY PRODUCT FORM
  ========================================================= */

  const productFormElement =
    document.querySelector("product-form");

  const productForm =
    productFormElement?.querySelector("form") ||
    document.querySelector(
      'form[action*="/cart/add"]'
    );

  if (!productForm) {
    console.error(
      "Wublue Sticky Cart: Product form not found."
    );
    return;
  }


  const mainAddButton =
    productForm.querySelector(
      'button[type="submit"]'
    );


  /* =========================================================
     QUANTITY ELEMENTS
  ========================================================= */

  const mainQty =
    productForm.querySelector(
      ".quantity__input"
    ) ||
    document.querySelector(
      ".quantity__input"
    );

  const stickyQty =
    document.getElementById(
      "wbQty"
    );


  /* =========================================================
     MONEY FORMAT
  ========================================================= */

  function formatMoney(cents) {

    cents = Number(cents || 0);

    if (
      typeof Shopify !== "undefined" &&
      typeof Shopify.formatMoney === "function"
    ) {

      return Shopify.formatMoney(
        cents,
        window.shopifyMoneyFormat ||
        "₹{{amount}}"
      );

    }

    return "₹" +
      (cents / 100).toFixed(2);

  }


  /* =========================================================
     GET CURRENT VARIANT INPUT
  ========================================================= */

  function getVariantInput() {

    return (
      productForm.querySelector(
        'input[name="id"].product-variant-id'
      ) ||
      productForm.querySelector(
        'input[name="id"]'
      )
    );

  }


  /* =========================================================
     GET CURRENT VARIANT ID
  ========================================================= */

  function getCurrentVariantId() {

    const input =
      getVariantInput();

    if (
      input &&
      input.value
    ) {

      return String(
        input.value
      );

    }

    return null;

  }


  /* =========================================================
     UPDATE STICKY CART FROM VARIANT
  ========================================================= */

  let updateRequestNumber = 0;

  async function updateStickyVariant(
    variantId
  ) {

    if (!variantId) return;

    const requestNumber =
      ++updateRequestNumber;

    console.log(
      "Wublue Sticky → Loading variant:",
      variantId
    );


    try {

      const response =
        await fetch(
          `/variants/${variantId}.js`,
          {
            headers: {
              "Accept":
                "application/json"
            }
          }
        );


      if (!response.ok) {

        throw new Error(
          "Variant request failed: " +
          response.status
        );

      }


      const variant =
        await response.json();


      /*
       * If another variant was selected
       * while this request was loading,
       * ignore this old response.
       */

      if (
        requestNumber !==
        updateRequestNumber
      ) {

        return;

      }


      console.log(
        "Wublue Sticky → Current variant:",
        variant
      );


      /* =====================================================
         PRICE
      ===================================================== */

      const priceElement =
        document.getElementById(
          "wbStickyPrice"
        );

      if (priceElement) {

        priceElement.textContent =
          formatMoney(
            variant.price
          );

      }


      /* =====================================================
         COMPARE AT PRICE / MRP
      ===================================================== */

      const compareElement =
        document.getElementById(
          "wbStickyCompare"
        );

      if (compareElement) {

        const price =
          Number(
            variant.price || 0
          );

        const comparePrice =
          Number(
            variant.compare_at_price || 0
          );


        if (
          comparePrice > price
        ) {

          compareElement.style.display =
            "inline";

          compareElement.textContent =
            formatMoney(
              comparePrice
            );

        } else {

          compareElement.style.display =
            "none";

          compareElement.textContent =
            "";

        }

      }


      /* =====================================================
         VARIANT TITLE
      ===================================================== */

      const variantElement =
        document.getElementById(
          "wbStickyVariant"
        );

      if (variantElement) {

        variantElement.textContent =
          variant.title || "";

      }


      /* =====================================================
         STOCK
      ===================================================== */

      const stockElement =
        document.getElementById(
          "wbStickyStock"
        );

      if (stockElement) {

        if (variant.available) {

          stockElement.textContent =
            "In Stock";

          stockElement.style.color =
            "#16a34a";

        } else {

          stockElement.textContent =
            "Sold Out";

          stockElement.style.color =
            "#dc2626";

        }

      }


      /* =====================================================
         IMAGE
      ===================================================== */

      const imageElement =
        document.getElementById(
          "wbStickyImage"
        );


      if (
        imageElement &&
        variant.featured_image &&
        variant.featured_image.src
      ) {

        let imageUrl =
          variant.featured_image.src;


        /*
         * Remove an existing width parameter.
         */

        imageUrl =
          imageUrl.replace(
            /([?&])width=\d+/g,
            ""
          );


        imageElement.src =
          imageUrl +
          (
            imageUrl.includes("?")
              ? "&"
              : "?"
          ) +
          "width=120";

      }


      /* =====================================================
         ADD TO CART BUTTON
      ===================================================== */

      stickyBtn.disabled =
        !variant.available;

      stickyBtn.textContent =
        variant.available
          ? "Add to Cart"
          : "Sold Out";


      /*
       * Store the current variant ID.
       */

      stickyBtn.dataset.variantId =
        String(
          variant.id
        );

      sticky.dataset.variantId =
        String(
          variant.id
        );


    } catch (error) {

      console.error(
        "Wublue Sticky Cart Variant Error:",
        error
      );

    }

  }


  /* =========================================================
     INITIAL VARIANT
  ========================================================= */

  let lastVariantId =
    getCurrentVariantId();


  if (lastVariantId) {

    updateStickyVariant(
      lastVariantId
    );

  }


  /* =========================================================
     CHECK FOR VARIANT CHANGE
  ========================================================= */

  function checkForVariantChange() {

    const newVariantId =
      getCurrentVariantId();


    if (!newVariantId) {
      return;
    }


    if (
      newVariantId !==
      lastVariantId
    ) {

      console.log(
        "Wublue Sticky → Variant changed:",
        lastVariantId,
        "→",
        newVariantId
      );


      lastVariantId =
        newVariantId;


      updateStickyVariant(
        newVariantId
      );

    }

  }


  /* =========================================================
     LISTEN TO PRODUCT FORM CHANGES
  ========================================================= */

  productForm.addEventListener(
    "change",
    () => {

      /*
       * Rise may update the hidden
       * variant ID slightly after the
       * option change.
       */

      setTimeout(
        checkForVariantChange,
        50
      );

      setTimeout(
        checkForVariantChange,
        150
      );

      setTimeout(
        checkForVariantChange,
        300
      );

    }
  );


  /* =========================================================
     LISTEN TO ALL VARIANT OPTION CHANGES
     Useful for Rise / Dawn style pickers
  ========================================================= */

  document.addEventListener(
    "change",
    (event) => {

      const target =
        event.target;


      if (
        target.matches(
          'select[name^="options"],' +
          'input[name^="options"],' +
          'input[type="radio"]'
        )
      ) {

        setTimeout(
          checkForVariantChange,
          50
        );

        setTimeout(
          checkForVariantChange,
          150
        );

        setTimeout(
          checkForVariantChange,
          300
        );

      }

    }
  );


  /* =========================================================
     WATCH HIDDEN VARIANT INPUT
  ========================================================= */

  let variantInput =
    getVariantInput();


  if (variantInput) {

    /*
     * Watch changes to the value attribute.
     */

    const attributeObserver =
      new MutationObserver(
        () => {

          checkForVariantChange();

        }
      );


    attributeObserver.observe(
      variantInput,
      {
        attributes: true,
        attributeFilter: [
          "value"
        ]
      }
    );


    /*
     * Listen for direct change event.
     */

    variantInput.addEventListener(
      "change",
      () => {

        checkForVariantChange();

      }
    );

  }


  /* =========================================================
     RISE / CUSTOM VARIANT EVENT
  ========================================================= */

  document.addEventListener(
    "variant:change",
    (event) => {

      const variant =
        event.detail?.variant;


      if (
        variant &&
        variant.id
      ) {

        const id =
          String(
            variant.id
          );


        lastVariantId =
          id;


        updateStickyVariant(
          id
        );

      }

    }
  );


  /* =========================================================
     EXTRA SAFETY CHECK
     
     Rise sometimes changes the input
     property without changing its
     HTML attribute.
  ========================================================= */

  setInterval(
    checkForVariantChange,
    250
  );


  /* =========================================================
     QUANTITY SYNC
  ========================================================= */

  if (
    mainQty &&
    stickyQty
  ) {

    stickyQty.value =
      mainQty.value;


    /* -------------------------------------------------------
       Sticky → Main quantity
    ------------------------------------------------------- */

    stickyQty.addEventListener(
      "input",
      () => {

        mainQty.value =
          stickyQty.value;


        mainQty.dispatchEvent(
          new Event(
            "change",
            {
              bubbles: true
            }
          )
        );

      }
    );


    /* -------------------------------------------------------
       PLUS
    ------------------------------------------------------- */

    const plusButton =
      document.getElementById(
        "wbQtyPlus"
      );


    if (plusButton) {

      plusButton.onclick =
        () => {

          stickyQty.value =
            Number(
              stickyQty.value
            ) + 1;


          stickyQty.dispatchEvent(
            new Event(
              "input",
              {
                bubbles: true
              }
            )
          );

        };

    }


    /* -------------------------------------------------------
       MINUS
    ------------------------------------------------------- */

    const minusButton =
      document.getElementById(
        "wbQtyMinus"
      );


    if (minusButton) {

      minusButton.onclick =
        () => {

          const current =
            Number(
              stickyQty.value
            );


          if (current > 1) {

            stickyQty.value =
              current - 1;


            stickyQty.dispatchEvent(
              new Event(
                "input",
                {
                  bubbles: true
                }
              )
            );

          }

        };

    }

  }


  /* =========================================================
     MAIN QUANTITY → STICKY QUANTITY
  ========================================================= */

  if (
    mainQty &&
    stickyQty
  ) {

    mainQty.addEventListener(
      "change",
      () => {

        stickyQty.value =
          mainQty.value;

      }
    );


    mainQty.addEventListener(
      "input",
      () => {

        stickyQty.value =
          mainQty.value;

      }
    );

  }


  /* =========================================================
     STICKY ADD TO CART
  ========================================================= */

  stickyBtn.addEventListener(
    "click",
    () => {

      /*
       * Always make sure we have the
       * latest variant.
       */

      checkForVariantChange();


      /*
       * Use Shopify's REAL product
       * form.
       *
       * This means the currently
       * selected variant gets added.
       */

      if (mainAddButton) {

        mainAddButton.click();

      }

    }
  );


  /* =========================================================
     BUY NOW
  ========================================================= */

  if (buyBtn) {

    buyBtn.addEventListener(
      "click",
      () => {

        const dynamicButton =
          document.querySelector(
            ".shopify-payment-button__button"
          );


        if (dynamicButton) {

          dynamicButton.click();

        } else if (
          mainAddButton
        ) {

          mainAddButton.click();

        }

      }
    );

  }


  /* =========================================================
     SHOW / HIDE STICKY CART
  ========================================================= */

  if (mainAddButton) {

    const observer =
      new IntersectionObserver(
        (entries) => {

          if (
            entries[0].isIntersecting
          ) {

            sticky.classList.remove(
              "show"
            );

          } else {

            sticky.classList.add(
              "show"
            );

          }

        }
      );


    observer.observe(
      mainAddButton
    );

  }


  /* =========================================================
     UPSELL ADD TO CART
  ========================================================= */

  document.addEventListener(
    "click",
    async (event) => {

      const btn =
        event.target.closest(
          ".wb-upsell-add"
        );


      if (!btn) {
        return;
      }


      btn.disabled = true;
      btn.textContent =
        "Adding...";


      try {

        const response =
          await fetch(
            "/cart/add.js",
            {
              method: "POST",

              headers: {
                "Content-Type":
                  "application/json",

                "Accept":
                  "application/json"
              },

              body: JSON.stringify({

                id:
                  btn.dataset.variant,

                quantity: 1

              })

            }
          );


        if (!response.ok) {

          throw new Error(
            "Could not add upsell"
          );

        }


        const item =
          await response.json();


        if (
          typeof publish ===
          "function" &&
          typeof PUB_SUB_EVENTS !==
          "undefined"
        ) {

          publish(
            PUB_SUB_EVENTS.cartUpdate,
            {
              source:
                "upsell",

              productVariantId:
                item.variant_id
            }
          );

        }

      } catch (error) {

        console.error(
          "Wublue Upsell Error:",
          error
        );

      } finally {

        btn.disabled = false;
        btn.textContent =
          "Add";

      }

    }
  );


});

/* =========================================================
   WUBLUE OFFER CARDS
   Stable Shopify Rise version
   Price + MRP + Discount %
========================================================= */

document.addEventListener("DOMContentLoaded", function () {

  let productData = null;
  let updateTimer = null;
  let observer = null;
  let isUpdating = false;


  /* =======================================================
     PRODUCT HANDLE
  ======================================================= */

  const match =
    window.location.pathname.match(
      /\/products\/([^\/?#]+)/
    );

  if (!match) return;

  const productHandle = match[1];


  /* =======================================================
     LOAD PRODUCT DATA
  ======================================================= */

  fetch(`/products/${productHandle}.js`)
    .then(response => response.json())
    .then(product => {

      productData = product;

      /*
        Wait for Shopify's product form
        to finish rendering.
      */

      setTimeout(() => {

        updateOfferCards();

        startObserver();

      }, 100);

    })
    .catch(error => {

      console.error(
        "Wublue Offer Cards:",
        error
      );

    });


  /* =======================================================
     MONEY
  ======================================================= */

  function formatMoney(cents) {

    if (
      typeof Shopify !== "undefined" &&
      typeof Shopify.formatMoney === "function"
    ) {

      return Shopify.formatMoney(
        cents,
        window.shopifyMoneyFormat ||
        "₹{{amount}}"
      );

    }

    return "₹" +
      (Number(cents) / 100).toLocaleString(
        "en-IN",
        {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }
      );

  }


  /* =======================================================
     FIND OFFER GROUP
  ======================================================= */

  function findOfferGroup() {

    const groups =
      document.querySelectorAll(
        ".product-form__input"
      );


    for (const group of groups) {

      const text =
        group.textContent
          .trim()
          .toLowerCase();


      if (
        text.includes("choose your offer") ||
        text.includes("bundle offers") ||
        text.includes("pack of")
      ) {

        return group;

      }

    }


    return null;

  }


  /* =======================================================
     SELECTED OPTIONS
  ======================================================= */

  function getSelectedOptions() {

    const selected = [];

    document.querySelectorAll(
      '.product-form__input input[type="radio"]:checked'
    ).forEach(input => {

      if (input.value) {

        selected.push(
          input.value
            .trim()
            .toLowerCase()
        );

      }

    });

    return selected;

  }


  /* =======================================================
     FIND VARIANT
  ======================================================= */

  function findVariant(offerInput) {

    if (!productData) return null;


    const offerValue =
      offerInput.value
        .trim()
        .toLowerCase();


    const selectedOptions =
      getSelectedOptions();


    /*
      Find variants matching the
      offer option.
    */

    const candidates =
      productData.variants.filter(
        variant => {

          return (
            variant.options || []
          ).some(option => {

            return (
              option
                .trim()
                .toLowerCase() ===
              offerValue
            );

          });

        }
      );


    if (!candidates.length) {

      return null;

    }


    /*
      Try exact color + offer match.
    */

    const exact =
      candidates.find(variant => {

        const variantOptions =
          (variant.options || [])
            .map(option =>
              option
                .trim()
                .toLowerCase()
            );


        return selectedOptions.every(
          selected => {

            return variantOptions.includes(
              selected
            );

          }
        );

      });


    return exact || candidates[0];

  }


  /* =======================================================
     UPDATE ONE CARD
  ======================================================= */

  function updateCard(
    label,
    variant
  ) {

    if (!label || !variant) return;


    let priceBox =
      label.querySelector(
        ":scope > .wb-offer-price"
      );


    /*
      Create price box
    */

    if (!priceBox) {

      priceBox =
        document.createElement(
          "span"
        );

      priceBox.className =
        "wb-offer-price";

      label.appendChild(
        priceBox
      );

    }


    /* =====================================================
       SELLING PRICE
    ===================================================== */

    let sellingPrice =
      priceBox.querySelector(
        ".wb-offer-selling-price"
      );


    if (!sellingPrice) {

      sellingPrice =
        document.createElement(
          "span"
        );

      sellingPrice.className =
        "wb-offer-selling-price";

      priceBox.appendChild(
        sellingPrice
      );

    }


    sellingPrice.textContent =
      formatMoney(
        variant.price
      );


    /* =====================================================
       MRP + DISCOUNT
    ===================================================== */

    const hasDiscount =
      Number(variant.compare_at_price) >
      Number(variant.price);


    let mrp =
      priceBox.querySelector(
        ".wb-offer-mrp"
      );


    let discountBadge =
      priceBox.querySelector(
        ".wb-offer-discount"
      );


    if (hasDiscount) {

      /* MRP */

      if (!mrp) {

        mrp =
          document.createElement(
            "span"
          );

        mrp.className =
          "wb-offer-mrp";

        priceBox.appendChild(
          mrp
        );

      }


      mrp.textContent =
        formatMoney(
          variant.compare_at_price
        );


      /* Discount */

      if (!discountBadge) {

        discountBadge =
          document.createElement(
            "span"
          );

        discountBadge.className =
          "wb-offer-discount";

        priceBox.appendChild(
          discountBadge
        );

      }


      const discount =
        Math.round(
          (
            (
              variant.compare_at_price -
              variant.price
            ) /
            variant.compare_at_price
          ) * 100
        );


      discountBadge.textContent =
        `${discount}% OFF`;

    } else {

      if (mrp) {

        mrp.remove();

      }


      if (discountBadge) {

        discountBadge.remove();

      }

    }

  }


  /* =======================================================
     UPDATE ALL CARDS
  ======================================================= */

  function updateOfferCards() {

    if (!productData) return;

    if (isUpdating) return;


    const group =
      findOfferGroup();


    if (!group) return;


    const inputs =
      group.querySelectorAll(
        'input[type="radio"]'
      );


    if (!inputs.length) return;


    isUpdating = true;


    inputs.forEach(input => {

      const label =
        group.querySelector(
          `label[for="${input.id}"]`
        );


      if (!label) return;


      const variant =
        findVariant(input);


      if (!variant) return;


      updateCard(
        label,
        variant
      );

    });


    isUpdating = false;

  }


  /* =======================================================
     SCHEDULE UPDATE
  ======================================================= */

  function scheduleUpdate(delay = 100) {

    clearTimeout(
      updateTimer
    );


    updateTimer =
      setTimeout(
        function () {

          updateOfferCards();

        },
        delay
      );

  }


  /* =======================================================
     SHOPIFY VARIANT CHANGE
  ======================================================= */

  document.addEventListener(
    "variant:change",
    function () {

      /*
        Shopify may replace the labels
        immediately after this event.

        Wait for that process to finish.
      */

      scheduleUpdate(150);

      setTimeout(
        () => updateOfferCards(),
        400
      );

      setTimeout(
        () => updateOfferCards(),
        800
      );

    }
  );


  /* =======================================================
     RADIO CHANGE
  ======================================================= */

  document.addEventListener(
    "change",
    function (event) {

      if (
        !event.target.matches(
          '.product-form__input input[type="radio"]'
        )
      ) {

        return;

      }


      /*
        Let Shopify process the
        selected variant first.
      */

      scheduleUpdate(200);

    }
  );


  /* =======================================================
     TARGETED MUTATION OBSERVER
  ======================================================= */

  function startObserver() {

    /*
      Observe the product-info element,
      NOT the entire document.
    */

    const container =
      document.querySelector(
        "product-info"
      ) ||
      document.querySelector(
        ".product"
      );


    if (!container) return;


    observer =
      new MutationObserver(
        function (mutations) {

          /*
            Ignore mutations caused by
            our own price box.
          */

          let ShopifyChanged =
            false;


          mutations.forEach(
            mutation => {

              if (
                mutation.type !==
                "childList"
              ) {

                return;

              }


              const target =
                mutation.target;


              /*
                If mutation is inside
                our price box, ignore it.
              */

              if (
                target.closest &&
                target.closest(
                  ".wb-offer-price"
                )
              ) {

                return;

              }


              /*
                Check if Shopify has
                changed/rebuilt the
                offer picker.
              */

              const group =
                findOfferGroup();


              if (
                group &&
                group.querySelector(
                  'input[type="radio"]'
                )
              ) {

                const missingPrice =
                  group.querySelectorAll(
                    'input[type="radio"]'
                  ).length !==
                  group.querySelectorAll(
                    ".wb-offer-price"
                  ).length;


                if (missingPrice) {

                  ShopifyChanged = true;

                }

              }

            }
          );


          if (ShopifyChanged) {

            scheduleUpdate(80);

          }

        }
      );


    observer.observe(
      container,
      {
        childList: true,
        subtree: true
      }
    );

  }


});